export const SearchStatus = api => ({
  update(slug, status) {
    return api.put(`/v1/profiles/${slug}/search-status`, { status })
  }
})
